<template lang="html">
  <div class="model-nav">
    <ModelNavButton
      v-for="(item, index) in navList"
      :key="index"
      :label="item.label"
      :idle="item.icons.idle"
      :pressed="item.icons.pressed"
      :active="selectedItem === item"
      @click="onButtonClicked(item)" />
  </div>
</template>

<script>
import ModelNavButton from "./model-nav-button.vue";

export default {
  name: "ModelNav",
  components: {
    ModelNavButton
  },
  data() {
    return {
      navList: [
        {
          label: "返回列表",
          icons: {
            idle: "/img/views/models/back.png",
            pressed: "/img/views/models/back-selected.png"
          }
        },
        {
          label: "基本信息",
          route: "info",
          icons: {
            idle: "/img/views/models/info.png",
            pressed: "/img/views/models/info-selected.png"
          }
        },
        {
          label: "加载界面",
          route: "loading",
          icons: {
            idle: "/img/views/models/loading.png",
            pressed: "/img/views/models/loading-selected.png"
          }
        },
        {
          label: "漫游设置",
          route: "vr-settings",
          icons: {
            idle: "/img/views/models/vr-settings.png",
            pressed: "/img/views/models/vr-settings-selected.png"
          }
        },
        {
          label: "标签管理",
          route: "label-management",
          icons: {
            idle: "/img/views/models/label-management.png",
            pressed: "/img/views/models/label-management-selected.png"
          }
        },
        {
          label: "商品管理",
          route: "item-management",
          icons: {
            idle: "/img/views/models/item-management.png",
            pressed: "/img/views/models/item-management-selected.png"
          }
        },
        {
          label: "户型标注",
          route: "house-marking",
          icons: {
            idle: "/img/views/models/item-management.png",
            pressed: "/img/views/models/item-management-selected.png"
          }
        },
        {
          label: "图片管理",
          route: "image-editor",
          icons: {
            idle: "/img/views/models/item-management.png",
            pressed: "/img/views/models/item-management-selected.png"
          }
        },
        {
          label: "漫游动画",
          route: "vr-roam",
          icons: {
            idle: "/img/views/models/vr-roam.png",
            pressed: "/img/views/models/vr-roam-selected.png"
          }
        },
        {
          label: "视频上传",
          route: "vr-videoUpload",
          icons: {
            idle: "/img/views/models/loading.png",
            pressed: "/img/views/models/loading-selected.png"
          }
        },
        {
          label: "CAD",
          route: "cad-alignmeted",
          icons: {
            idle: "/img/views/models/vr-roam.png",
            pressed: "/img/views/models/vr-roam-selected.png"
          }
        }
      ]
    };
  },
  computed: {
    selectedItem() {
      const routes = /(?:(?:[^/]*\/)+x\/models\/\d+\/editor\/)([^/]+)/g.exec(
        this.$route.path
      );
      if (routes && routes.length > 1) {
        const route = routes[1];
        return this.navList.find(i => i.route === route);
      }
      return null;
    }
  },
  mounted() {},
  methods: {
    onButtonClicked(item) {
      if (item.label === "返回列表") {
        this.$emit("nav-clicked", "/x/models");
        return;
      }
      this.$emit(
        "nav-clicked",
        `/x/models/${this.$route.params.modelId}/editor/${item.route}`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.model-nav {
  width: 129px;
  background-color: #ddeffb;
  border-right: 1px solid #bacfdf;
  overflow-y: scroll;
}
</style>
